import { FC } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AlertPopup } from '../components/alertPopup/AlertPopup';
import { PrivateRoute } from '../components/privateRoute/PrivateRoute';
import { CardsPage } from '../pages/cardsPage/CardsPage';
import { CreateOpportunity } from '../pages/createOpportunity/CreateOpportunity';
import { CreatePassword } from '../pages/createPassword/CreatePassword';
import { EditOpportunity } from '../pages/editOpportunity/EditOpportunity';
import { Login } from '../pages/login/Login';
import { Main } from '../pages/main/Main';
import { NotFoundPage } from '../pages/notFoundPage/NotFoundPage';
import { NoticePage } from '../pages/noticePage/NoticePage';
import { OpportunityDetails } from '../pages/opportunityDetails/OpportunityDetails';
import { ResetPassword } from '../pages/resetPassword/ResetPassword';
import { VerifyCode } from '../pages/verifyCode/VerifyCode';
import { ViewProfile } from '../pages/viewProfile/ViewProfile';
import { routesNames } from '../utils/constants';

export const Routing: FC = () => {
  const dsn = 'your-project-dsn';
  // useEffect(() => {
  //   Sentry.init({
  //     dsn: dsn,
  //     integrations: [
  //       new Integrations.BrowserTracing(),
  //     ],
  //     tracesSampleRate: 1.0,
  //   });
  // }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path={routesNames.main}
          element={
            <PrivateRoute>
              <Main />
            </PrivateRoute>
          }
        >
          <Route path={routesNames.main} element={<CardsPage />} />
        </Route>
        <Route path={routesNames.logIn} element={<Login />} />
        <Route path={routesNames.notice} element={<NoticePage />} />
        <Route path={routesNames.profile} element={<ViewProfile />} />
        <Route path={routesNames.notFound} element={<NotFoundPage />} />
        <Route path={routesNames.verifyCode} element={<VerifyCode />} />
        <Route path={routesNames.details} element={<OpportunityDetails />} />
        <Route path={routesNames.resetPassword} element={<ResetPassword />} />
        <Route path={routesNames.createPassword} element={<CreatePassword />} />
        <Route path={routesNames.editOpportunity} element={<EditOpportunity />} />
        <Route path={routesNames.createOpportunity} element={<CreateOpportunity />} />
        <Route path={routesNames.init} element={ <Navigate replace={true} to={routesNames.main} /> } />
      </Routes>
      <AlertPopup />
    </BrowserRouter>
  );
};
